import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import {
  fetchCollective,
  updateCollective,
  fetchFilterOptions,
  fetchPolicies
} from '../actions';

import ParentAccountSearch from '../components/forms/ParentAccountSearch';
import EditableTextField from '../components/forms/EditableTextField';
import MultipleSelectEdit from '../components/forms/MultipleSelectEdit';
import EditablePolicies from '../components/forms/EditablePolicies';
import EditableCollection from '../components/forms/EditableCollection';
import EditableSelectField from '../components/forms/EditableSelectField';
import LoadingOverlay from '../components/LoadingOverlay';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import css from '../components/forms/forms.css';

// Material UI Library
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Checkbox from 'material-ui/Checkbox';

class EditCollective extends Component {

  componentDidMount() {
    this.props.dispatch(fetchCollective(this.props.collectiveId));

    if (!this.props.isFetching && this.props.socialMedia.get('result').size === 0) {
      this.props.dispatch(fetchFilterOptions());
    }

    if (!this.props.isFetching && this.props.policies.get('result').size === 0) {
      this.props.dispatch(fetchPolicies());
    }

  }

  handleUpdate = (key, newValue) => {
    this.props.dispatch(
      updateCollective(this.props.collectiveId, {
        collective: {
          [key]: newValue,
        },
      })
    );
  };

  handleSelectMenu = (key, e, i, newValue) => {
    this.props.dispatch(
      updateCollective(this.props.collectiveId, {
        collective: {
          [key]: newValue,
        },
      })
    );
  };

  handleUpdateContact = (key, newValue) => {
    this.props.dispatch(
      updateCollective(this.props.collectiveId, {
        collective: {
          contactAttributes: {
            [key]: newValue,
          },
        },
      })
    );
  };

  handleSelectMenuContact = (key, e, i, newValue) => {
    this.props.dispatch(
      updateCollective(this.props.collectiveId, {
        collective: {
          contactAttributes: {
            [key]: newValue,
          },
        },
      })
    );
  };

  handleChecked = (property, e, value) => {
    this.handleUpdate(property, value);
  };

  formStyles = () => ({
    checkboxContainer: {
      width: 'auto',
    },
    radio: {
      width: '100%',
    },
  });

  render() {
    if (!this.props.collective || !this.props.collective.get('id')) return <div></div>;

      const styles = {
        checkbox: {
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          width: 150,
        },
      };

    return (
      <div className={css.root} style={{ position: 'relative' }}>
        <section>
          <EditableTextField
            name="name"
            floatingLabelText="Account Name"
            fullWidth={true}
            value={this.props.collective.get('name')}
            saveValue={this.handleUpdate.bind(this, 'name')}
          />
        </section>
        <section>
          <ParentAccountSearch
            className={css.textField}
            fullWidth={true}
            hintText={this.props.collective.get('parentName')}
            updateForm={this.handleUpdate.bind(this, 'collectiveId')}
          />
        </section>
        <h3 className={css.title}>Collective Type</h3>
        <section>
          <RadioButtonGroup
            key="collective-type"
            name="type"
            valueSelected={this.props.collective.get('type')}
            labelPosition="left"
            onChange={this.handleChecked.bind(this, 'type')}
          >
            <RadioButton
              value="NewMediaCollective"
              label="Influencer"
              style={this.formStyles().radio}
              className={css.formField}
            />
            <RadioButton
              value="TraditionalMediaCollective"
              label="Media"
              style={this.formStyles().radio}
              className={css.formField}
            />
          </RadioButtonGroup>
        </section>
        <h3 className={css.title}>Primary Contact</h3>
        <section>
          <SelectField
            hintText="Salutation"
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('salutation') : ''}
            onChange={this.handleSelectMenuContact.bind(this, 'salutation')}
            style={{ margin: '0 10px' }}
          >
            <MenuItem value={'Ms.'} primaryText="Ms." />
            <MenuItem value={'Mrs.'} primaryText="Mrs." />
            <MenuItem value={'Mr.'} primaryText="Mr." />
            <MenuItem value={'Dr.'} primaryText="Dr." />
            <MenuItem value={'Other'} primaryText="Other" />
          </SelectField>
          <EditableTextField
            name="firstName"
            floatingLabelText="First Name"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('firstName') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'firstName')}
          />
          <EditableTextField
            name="lastName"
            floatingLabelText="Last Name"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('lastName') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'lastName')}
          />
        </section>
        <section>
          <EditableTextField
            name="phone"
            floatingLabelText="Phone"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('phone') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'phone')}
          />
          <EditableTextField
            name="email"
            floatingLabelText="Email"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('email') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'email')}
          />
          <EditableTextField
            name="mobile"
            floatingLabelText="Mobile Phone"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('mobile') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'mobile')}
          />
          <EditableTextField
            name="fax"
            floatingLabelText="Fax"
            fullWidth={true}
            value={this.props.collective.get('contact') ? this.props.collective.get('contact').get('fax') : ''}
            saveValue={this.handleUpdateContact.bind(this, 'fax')}
          />
        </section>
        <h3 className={css.title}>Primary Address</h3>
        <SelectField
          hintText="Select Primary Address"
          value={this.props.collective.get('addressId')}
          onChange={this.handleSelectMenu.bind(this, 'addressId')}
          style={{ margin: '0 10px', width: '100%' }}
        >
          {this.props.collective.get('addresses') && this.props.collective.get('addresses').map(address =>
            <MenuItem  key={address.get('id')} value={address.get('id')} primaryText={address.get('street1')} />
          )}
        </SelectField>
        <EditableCollection
          name="addressesAttributes"
          collection={this.props.collective.get('addresses')}
          saveValue={this.handleUpdate.bind(this, 'addressesAttributes')}
          title="Addresses"
          multiLine={true}
        >
          <EditableTextField
            name="street1"
            floatingLabelText="Street Address"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="street2"
            floatingLabelText="Street Address 1"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="city"
            floatingLabelText="City"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="state"
            floatingLabelText="State"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
          <EditableTextField
            name="zip"
            floatingLabelText="Zip"
            type="text"
            fullWidth={true}
            className={css.singleLineField}
          />
        </EditableCollection>
        <LoadingOverlay loading={this.props.isFetching} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collective: state.get('collectives')
                          .get('items')
                          .get(`${state.get('location').get('options').get('id')}`),
    collectiveId: state.get('location').get('options').get('id'),
    socialMedia: state.get('filterOptions').get('socialMedia'),
    gamePlatforms: state.get('filterOptions').get('gamePlatforms'),
    gameGenres: state.get('filterOptions').get('gameGenres'),
    interests: state.get('filterOptions').get('interests'),
    policies: state.get('policies'),
    isFetching: state.get('collectives').get('isFetching')
                    || state.get('filterOptions').get('isFetching')
                    || state.get('policies').get('isFetching'),
  };
}

export default connect(mapStateToProps)(EditCollective);



/** WEBPACK FOOTER **
 ** ./containers/EditCollective.js
 **/